// Tipler ve seed veriler (TR içerik)
export type CityInfo = {
  slug: string;
  name: string;
  cover: string;
  teaser: string;
  highlights: string[];
  topAttractions: string[];
  localFoods: string[];
  bestSeason: string;
  oneDayPlan: { morning: string; noon: string; evening: string; budgetTRY: number };
};

export const cities: CityInfo[] = [
  {
    slug: 'istanbul',
    name: 'İstanbul',
    cover:
      'https://www.viaurbis.com/wp-content/uploads/2020/04/Istanbul-General-Information-1.jpg',
    teaser:
      'Boğaz, tarihi yarımada ve Kapalıçarşı ile kültürlerin buluşma noktası.',
    highlights: [
      'Boğaz turu ve vapurda simit-çay',
      'Ayasofya & Sultanahmet',
      'Kapalıçarşı ve Mısır Çarşısı',
      'Galata Kulesi, Karaköy ve Balat',
      'Mevsime göre Adalar kaçamağı',
    ],
    topAttractions: ['Ayasofya', 'Topkapı Sarayı', 'Kapalıçarşı', 'Galata Kulesi', 'Dolmabahçe'],
    localFoods: ['Simit & çay', 'Balık-ekmek', 'Vefa bozası', 'Kokoreç', 'Kumpir'],
    bestSeason: 'Nisan–Haziran, Eylül–Ekim',
    oneDayPlan: {
      morning: 'Sultanahmet’te kahvaltı ve Ayasofya/Topkapı ziyareti',
      noon: 'Eminönü’nde balık-ekmek, Kapalıçarşı turu',
      evening: 'Boğaz turu ve Karaköy’de akşam yemeği',
      budgetTRY: 1800,
    },
  },
  {
    slug: 'kapadokya',
    name: 'Kapadokya',
    cover:
      'https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=1600&auto=format&fit=crop',
    teaser:
      'Peri bacaları, balon turları ve yeraltı şehirleriyle masalsı bir coğrafya.',
    highlights: [
      'Gün doğumunda sıcak hava balonları',
      'Göreme Açık Hava Müzesi',
      'Derinkuyu yeraltı şehri',
      'Uçhisar Kalesi manzarası',
    ],
    topAttractions: ['Göreme', 'Uçhisar', 'Paşabağ', 'Derinkuyu', 'Ihlara Vadisi'],
    localFoods: ['Testi kebabı', 'Kayısı çekirdekli atıştırmalıklar', 'Erikli yaprak sarma'],
    bestSeason: 'Nisan–Haziran, Eylül–Ekim',
    oneDayPlan: {
      morning: 'Gün doğumunda balonları izleme / fotoğraf',
      noon: 'Göreme Açık Hava Müzesi ve yöresel öğle',
      evening: 'Uçhisar gün batımı ve testi kebabı',
      budgetTRY: 2200,
    },
  },
  {
    slug: 'antalya',
    name: 'Antalya',
    cover:
      'https://www.villanizburada.com/assets/images/blog/big/side_antik_kenti_drone_cekim_manzarasi.jpg',
    teaser:
      'Turkuaz sahiller, Kaleiçi ve antik kentlerle Akdeniz’in kalbi.',
    highlights: [
      'Kaleiçi sokakları ve marinada gün batımı',
      'Konyaaltı & Lara plajları',
      'Perge & Aspendos gibi antik kentler',
    ],
    topAttractions: ['Kaleiçi', 'Konyaaltı', 'Lara', 'Aspendos', 'Perge'],
    localFoods: ['Piyaz (tahinli)', 'Deniz ürünleri', 'Cezerye', 'Kabak tatlısı'],
    bestSeason: 'Nisan–Ekim',
    oneDayPlan: {
      morning: 'Kaleiçi kahvaltı ve gezinti',
      noon: 'Konyaaltı sahilinde deniz ve öğle',
      evening: 'Aspendos akustiğinde akşam etkinliği',
      budgetTRY: 2000,
    },
  },
  {
    slug: 'izmir',
    name: 'İzmir',
    cover:
      'https://www.novo-monde.com/app/uploads/2019/05/izmir-vue-1600x1087.jpg',
    teaser:
      'Kordon’da gün batımı, Konak Saat Kulesi ve Ege mutfağıyla yaşam dolu bir şehir.',
    highlights: [
      'Kordon boyunda gün batımı yürüyüşü',
      'Konak Saat Kulesi ve Kemeraltı Çarşısı',
      'Alsancak – Karşıyaka vapur turu',
      'Çeşme – Alaçatı rüzgârı (yakın kaçamak)'
    ],
    topAttractions: ['Konak Saat Kulesi', 'Kemeraltı', 'Asansör', 'Kadifekale', 'Efes Antik Kenti'],
    localFoods: ['Boyoz', 'Kumru', 'Söğüş', 'Midye dolma', 'İzmir lokması'],
    bestSeason: 'Mayıs–Haziran, Eylül–Ekim',
    oneDayPlan: {
      morning: 'Kemeraltı’nda kahvaltı, Konak Saat Kulesi ve Asansör ziyareti',
      noon: 'Alsancak – Kordon’da Ege mezeleri ile öğle',
      evening: 'Karşıyaka vapur turu ve gün batımı yürüyüşü',
      budgetTRY: 1900,
    },
  },
  {
    slug: 'trabzon',
    name: 'Trabzon',
    cover:
      'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/33/fd/4b/trabzon.jpg?w=1200&h=700&s=1',
    teaser:
      'Sümela Manastırı, yaylalar ve Karadeniz lezzetleriyle yeşilin bin tonu.',
    highlights: [
      'Sümela Manastırı’na doğa yürüyüşü',
      'Uzungöl ve kıyı şeridi',
      'Boztepe’de şehir manzarası',
      'Hıdırnebi ve yayla havası'
    ],
    topAttractions: ['Sümela Manastırı', 'Uzungöl', 'Atatürk Köşkü', 'Boztepe', 'Çal Mağarası'],
    localFoods: ['Kuymak/Muhlama', 'Hamsi tava', 'Akçaabat köftesi', 'Kara lahana çorbası'],
    bestSeason: 'Mayıs–Eylül (yaylalar), kışın sisli/serin',
    oneDayPlan: {
      morning: 'Sümela yürüyüşü ve orman içinde kahvaltı',
      noon: 'Uzungöl çevresinde gezinti ve yöresel öğle',
      evening: 'Boztepe’de çay ve sahil hattında akşam',
      budgetTRY: 1700,
    },
  },
  {
    slug: 'bursa',
    name: 'Bursa',
    cover:
      'https://blog.obilet.com/wp-content/uploads/2018/05/anagorsel-min-min-scaled.jpeg',
    teaser:
      'Uludağ, Osmanlı mirası ve İskender kebap ile tarih ve doğanın buluşması.',
    highlights: [
      'Ulucami, Koza Han ve kapalı çarşılar',
      'Cumalıkızık’ta taş sokaklar',
      'Uludağ teleferik ve doğa',
      'Kaplıcalarda dinlenme'
    ],
    topAttractions: ['Ulucami', 'Koza Han', 'Cumalıkızık', 'Yeşil Türbe', 'Uludağ'],
    localFoods: ['İskender kebap', 'Kestane şekeri', 'Pideli köfte', 'Cantık'],
    bestSeason: 'Aralık–Mart (kayak), Nisan–Haziran ve Eylül–Kasım (şehir)',
    oneDayPlan: {
      morning: 'Ulucami ve Koza Han gezisi, kahvaltıda tahinli pide',
      noon: 'İskender kebap ve Yeşil Türbe ziyareti',
      evening: 'Cumalıkızık’ta yürüyüş ve Uludağ eteklerinde çay',
      budgetTRY: 2000,
    },
  },
];
